module.exports = __webpack_public_path__ + "img/Review Icon - white.8c7fa85b.svg";